export class PumpTechnology {
    PumpTechnologyID: number;
    PumpTechnologies: string;
    PumpTechnologyDescription: string;
    IsActive: boolean = true;
    ModifiedBy: number;
}